"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
function SvgError404(props) {
    return ((0, jsx_runtime_1.jsxs)("svg", __assign({ viewBox: "0 0 40 40", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props, { children: [(0, jsx_runtime_1.jsx)("path", { d: "M3 31h34", stroke: "currentColor", strokeWidth: 2, strokeLinecap: "round" }, void 0), (0, jsx_runtime_1.jsx)("rect", { x: 7, y: 9, width: 26, height: 18, rx: 1.895, stroke: "currentColor", strokeWidth: 2 }, void 0), (0, jsx_runtime_1.jsx)("path", { d: "M15.793 20.793a1 1 0 001.414 1.414l-1.414-1.414zm8.414-5.586a1 1 0 00-1.414-1.414l1.414 1.414zm-7 7l7-7-1.414-1.414-7 7 1.414 1.414z", fill: "currentColor" }, void 0), (0, jsx_runtime_1.jsx)("path", { d: "M17.207 13.793a1 1 0 00-1.414 1.414l1.414-1.414zm5.586 8.414a1 1 0 001.414-1.414l-1.414 1.414zm-7-7l7 7 1.414-1.414-7-7-1.414 1.414z", fill: "currentColor" }, void 0)] }), void 0));
}
exports.default = SvgError404;
//# sourceMappingURL=Error404.js.map